import { create } from "zustand";

export interface IPriceConfigTab {
  id: number;
  displayName: string;
  configJson: string;
}

export const defaultConfigTab: IPriceConfigTab = {
  id: -1,
  displayName: "Default",
  configJson: "",
};

// LQC-2575 - a user may create up to 10 configs. Default is always present and is not
// one the user made, so it does not count towards the limit.
export const MAX_PRICE_CONFIGS = 10;

export function returnUserCreatedConfigs(
  configs: IPriceConfigTab[],
): IPriceConfigTab[] {
  return configs.filter((config) => config.id != defaultConfigTab.id);
}

export function isAtPriceConfigLimit(configs: IPriceConfigTab[]): boolean {
  return returnUserCreatedConfigs(configs).length >= MAX_PRICE_CONFIGS;
}

export interface IactivePricesConfigIdNumberStoreArr {
  crypto: string | undefined;
  activeTabId: number;
}

export type State = {
  priceConfigTabs: IPriceConfigTab[];
  activePricesConfigIdNumberStoreArr: IactivePricesConfigIdNumberStoreArr[];
};

export type Action = {
  // eslint-disable-next-line no-unused-vars
  setPriceConfigTabs: (priceConfigTabs: State["priceConfigTabs"]) => void;

  setActivePricesConfigIdNumberStoreArr: (
    // eslint-disable-next-line no-unused-vars
    activePricesConfigIdNumberStoreArr: State["activePricesConfigIdNumberStoreArr"],
  ) => void;
};

const priceTabStore = create<State & Action>((set) => ({
  priceConfigTabs: [],
  activePricesConfigIdNumberStoreArr: [],
  setPriceConfigTabs: (incomingData) => {
    set(() => ({
      priceConfigTabs: incomingData,
    }));
  },
  setActivePricesConfigIdNumberStoreArr: (incomingData) => {
    set(() => ({
      activePricesConfigIdNumberStoreArr: incomingData,
    }));
  },
}));

export default priceTabStore;
